import React, { useEffect } from 'react';
import useAuth from '../context/authContext';
import Router from 'next/router';

// for signin page to redirect it to home when user already authenticated
const withAlreadyAuth = (Component) => {
  return () => {
    const { isAuthenticated, loading } = useAuth();

    useEffect(() => {
      if (isAuthenticated && !loading) Router.push('/');
    }, [loading, isAuthenticated]);

    return <Component {...arguments} />;
  };
};

export default withAlreadyAuth;
